import React, { useRef, useState } from 'react';
import {Link as ScrollLink} from 'react-scroll';
import {Link} from "react-router-dom";

//Images
import logo from "../Images/c_1.png";

export default function Header() {
    const header = useRef(null);
    const image = useRef(null);
    const [isOffScreen, setIsOffScreen] = useState(false);

    const [isOpen, setIsOpen] = useState(null);
    const sideBar = useRef(null);

    const toggleIsOpen = () =>{
        if(isOpen != null){setIsOpen(!isOpen);}
        else{setIsOpen(true)}
    }

    const getIsOpen = () =>{
        if(isOpen === null)
        {
            return "close";
        }
        else if(isOpen === true)
        {
            return "Header-sidebar";
        }

        return "Header-sidebar close";
    }


    window.onscroll = () =>{
        if(document.body.scrollTop > 95 || document.documentElement.scrollTop > 95)
        {
            setIsOffScreen(true);
        }
        else
        {
            setIsOffScreen(false);
        }      
    };

    return (
        <div className = {isOffScreen? "Header scroll": "Header"} ref = {header}>
            <nav className = "Header-nav">
                <Link to ="/">Home <div className = "underline"/></Link>

                <ScrollLink to ="About"
                spy={true} smooth={true} offset={-90}>About <div className = "underline"/></ScrollLink>

                <ScrollLink to ="Reviews"
                spy={true} smooth={true} offset={-90}>Reviews <div className = "underline"/></ScrollLink>
            </nav>

            <div className = {isOffScreen? "Header-image-container": "Header-image-container"}
            ref = {image}>
                <img className = "Header-icon" src = {logo} alt = "Cabreras Logo"/>
            </div>

            <nav className = "Header-nav">
                <Link to ="/Promotions">Promotions<div className = "underline"/></Link>

                <Link to ="/Menu">Menu<div className = "underline"/></Link>

                <Link to ="/Contact">Contact Us<div className = "underline"/></Link>
            </nav>

            <button className = "Header-drop-down" onClick={toggleIsOpen}>
                <i className="fas fa-bars"/>
            </button>

            <div className = {getIsOpen()} ref={sideBar}>
                <Link to ="/"><i className="fas fa-home"
                onClick = {() => {setIsOpen(false)}}    
                /> <div className = "underline"/></Link>

                <Link to ="/menu"
                onClick = {() => {setIsOpen(false)}}>Menu <div className = "underline"/></Link>

                <Link to ="/promotions"
                onClick = {() => {setIsOpen(false)}}>Promotions<div className = "underline"/></Link>
                
                <Link to ="Contact"
                onClick = {() => {setIsOpen(false)}}>Contact<div className = "underline"/></Link>
            </div>
        </div>
    )
}
